import axios, { AxiosResponse } from 'axios';

import { AppDispatch } from '../store/store';
import { setState as setMasterPrefecture } from '../slice/MasterPrefectureSlice';
import { setState as setMasterInquire } from '../slice/MasterInquireSlice';
import { setState as setMasterSla } from '../slice/MasterSlaSlice';
import { MasterPrefectureApiResponse, MASTER_PREFECTURE_API_ERRORS } from '../types/api/MasterPrefectureApiType';
import { MasterInquireApiResponse, MASTER_INQUIRE_API_ERRORS } from '../types/api/MasterInquireApiType';
import { MasterSlaApiResponse, MASTER_SLA_API_ERRORS } from '../types/api/MasterSlaApiType';

// 都道府県マスタ取得 API-9001
const getMasterPrefecture = async (dispatch: AppDispatch) => {
    try {
        const result: AxiosResponse<MasterPrefectureApiResponse> = await axios.get('/api/master/prefecture');
        if (result.data) {
            dispatch(setMasterPrefecture(result.data));
            return '';
        } else {
            return MASTER_PREFECTURE_API_ERRORS.REQUEST_ERROR_9001;
        }
    } catch (error) {
        // リクエストが異常終了
        let error_ret = MASTER_PREFECTURE_API_ERRORS.REQUEST_ERROR_9001;
        if (axios.isAxiosError(error)) {
            if (error.response?.status) {
                // ステータスコードが設定されていた場合、ステータスコードを設定
                error_ret = MASTER_PREFECTURE_API_ERRORS.REQUEST_ERROR_9001_STATUS_CODE.replace(
                    '%1',
                    error.response.status as unknown as string
                );
            }
        }
        return error_ret;
    }
};

// お問い合わせマスタ取得 API-9002
const getMasterInquire = async (dispatch: AppDispatch) => {
    try {
        const result: AxiosResponse<MasterInquireApiResponse> = await axios.get('/api/master/inquire');
        if (result.data) {
            dispatch(setMasterInquire(result.data));
            return '';
        } else {
            return MASTER_INQUIRE_API_ERRORS.REQUEST_ERROR_9002;
        }
    } catch (error) {
        // リクエストが異常終了
        let error_ret = MASTER_INQUIRE_API_ERRORS.REQUEST_ERROR_9002;
        if (axios.isAxiosError(error)) {
            if (error.response?.status) {
                // ステータスコードが設定されていた場合、ステータスコードを設定
                error_ret = MASTER_INQUIRE_API_ERRORS.REQUEST_ERROR_9002_STATUS_CODE.replace(
                    '%1',
                    error.response.status as unknown as string
                );
            }
        }
        return error_ret;
    }
};

// 保守レベルのマスタ取得 API-9003
const getMasterSla = async (dispatch: AppDispatch) => {
    try {
        const result: AxiosResponse<Array<MasterSlaApiResponse>> = await axios.get('/api/master/sla');
        if (result.data) {
            dispatch(setMasterSla(result.data));
            return '';
        } else {
            return MASTER_SLA_API_ERRORS.REQUEST_ERROR_9003;
        }
    } catch (error) {
        // リクエストが異常終了
        let error_ret = MASTER_SLA_API_ERRORS.REQUEST_ERROR_9003;
        if (axios.isAxiosError(error)) {
            if (error.response?.status) {
                // ステータスコードが設定されていた場合、ステータスコードを設定
                error_ret = MASTER_SLA_API_ERRORS.REQUEST_ERROR_9003_STATUS_CODE.replace(
                    '%1',
                    error.response.status as unknown as string
                );
            }
        }
        return error_ret;
    }
};

export const masterApi = {
    getMasterPrefecture,
    getMasterInquire,
    getMasterSla,
};
